import { useId, useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button';
import {
  EstimateResultAttachmentsDialog,
  EstimateResultAttachmentsResult,
} from '~/shared/components/ui/Dialog';

export const UISampleEstimateResultAttachmentsDialogs = () => {
  const [isShow, setShow] = useState(false);
  const [result, setResult] = useState<EstimateResultAttachmentsResult | null>(
    null
  );

  return (
    <div className="categories">
      <h3 id="dialog">回答添付ファイル編集ダイアログ</h3>

      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setShow(true);
              }}
            />
            <EstimateResultAttachmentsDialog
              isOpen={isShow}
              inputOption={{
                files: [...(result?.files || [])],
              }}
              messageOption={{
                headerLabelId: {
                  id: 'estimate_result_attachments',
                  prefixId: 'DIALOG_TITLE',
                },
              }}
              uploadOption={{
                validateOption: {
                  allowedFileExtensions: ['xls', 'xlsx', 'pdf', 'txt'],
                  maxFileSizeInMebis: 10,
                  maxFileCount: 5,
                },
              }}
              onCancel={() => {
                setShow(false);
              }}
              onDecision={(result) => {
                setResult({
                  ...result,
                  // 永続化されたことを再現するため assetId に適当な値をセットする
                  files: (result.files ?? []).map((item, index) => ({
                    ...item,
                    assetId: index.toString(),
                  })),
                });
                setShow(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">
              {result && JSON.stringify(result, null, 2)}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};
